import React, { useMemo } from 'react';
import { Modal, Table, Button } from 'antd';
import { Link } from "react-router-dom";
import { FilterDropdown } from '../FilterDropdown';
import { createFilterOptions } from "../Utils";
import { getIndicatorName } from "../../utils/indicatorName";

export const IndicatorTableShowModal = ({ visible, record, onCancel, indicators }) => {
    console.log(indicators);
    const rows = useMemo(() => (indicators || []).map(ind => ({ ...ind, display_name: getIndicatorName(ind) || '' })), [indicators]);
    const indicatorFilterOptions = useMemo(() => createFilterOptions(rows, 'display_name'), [rows]);
    
    return <Modal
        visible={visible}
        title={`Indicators`}
        onCancel={onCancel}
        footer={[
            <Button key="cancel" onClick={onCancel}>
                Close
            </Button>,
        ]}
        width="80%"
        destroyOnClose={true}
    >
        <Table
            rowKey="ind_code"
            dataSource={rows}
            columns={[
                { 
                    title: 'Code', 
                    dataIndex: 'ind_code',
                    sorter: (a, b) => a.ind_code - b.ind_code,
                    render: (indCode) => <Link to={`/indicator/${indCode}`}>{indCode}</Link>,
                },
                { 
                    title: 'Name', 
                    dataIndex: 'display_name',
                    filters: indicatorFilterOptions,
                    onFilter: (value, record) => record.display_name === value,
                    sorter: (a, b) => a.display_name.localeCompare(b.display_name),
                    render: (displayName, record) => <Link to={`/indicator/${record.ind_code}`}>{displayName}</Link>,
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            options={indicatorFilterOptions}
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                        />
                    ),
                },
                { title: 'Explanation', dataIndex: 'ind_eng_exp' },
            ]}
            size="small"
            pagination={{ pageSize: 50 }}
        />
    </Modal>
};